import { BarChart3 } from "lucide-react";
import { Card, CardContent, CardHeader } from "../../ui/card";
import type { ProCampaignResultsRender } from "../../../lib/pro-agent-types";

// get_campaign_results read widget (SILL-454) — a delivery-status card for one
// campaign. It carries ONLY the three delivery counts the ledger returns
// (sent / failed / suppressed) and an explicit no-open/click caveat, so the
// model can't invent an engagement rate and the pro sees the real numbers
// instead of model prose. Read-only.

function Stat({
  label,
  value,
  tone,
}: {
  label: string;
  value: number;
  tone: "sent" | "failed" | "suppressed";
}) {
  const valueClass =
    tone === "failed"
      ? "text-destructive"
      : tone === "suppressed"
        ? "text-fg-muted"
        : "text-fg";
  return (
    <div className="min-w-0 flex-1">
      <p className={`text-lg font-semibold tabular-nums ${valueClass}`}>
        {value}
      </p>
      <p className="text-[11px] font-semibold uppercase tracking-wide text-fg-muted">
        {label}
      </p>
    </div>
  );
}

export function CampaignResultsCard({
  card,
}: {
  card: ProCampaignResultsRender;
}) {
  return (
    <Card data-testid="campaign-results-card">
      <CardHeader className="gap-1 pb-2">
        <div className="flex items-center gap-1.5">
          <BarChart3 size={13} aria-hidden className="text-fg-muted" />
          <p className="text-sm font-semibold text-fg">Delivery</p>
        </div>
      </CardHeader>

      <CardContent className="pt-0">
        <div className="flex gap-3 border-t border-border-soft pt-2.5">
          <Stat label="Sent" value={card.sent_count} tone="sent" />
          <Stat label="Failed" value={card.failed_count} tone="failed" />
          <Stat
            label="Suppressed"
            value={card.suppressed_count}
            tone="suppressed"
          />
        </div>
        <p className="mt-2 text-[11px] text-fg-muted">
          Delivery status only — no open or click tracking in this system.
        </p>
      </CardContent>
    </Card>
  );
}
